import React from "react";
import Instructions from "./Instructions";

const OnScreenInstructions = () => {
  return (
    // <div className="absolute z-20 bottom-0 left-0 p-4 m-8 bg-black bg-opacity-75 flex flex-col justify-center items-center bg-no-repeat bg-center bg-cover">
    <div className="p-4 bg-black bg-opacity-75 flex flex-col justify-center items-center bg-no-repeat bg-center bg-cover">
      <Instructions />
    </div>
  );
};

export default OnScreenInstructions;
